import { render, staticRenderFns } from "./ModalTermsOfUse.vue?vue&type=template&id=4fb474a4&scoped=true&"
import script from "./ModalTermsOfUse.vue?vue&type=script&lang=js&"
export * from "./ModalTermsOfUse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb474a4",
  null
  
)

export default component.exports